import { Box, type BoxProps, styled } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'
import { typeScale } from '@/shared/styles/typography'

type Tone = 'neutral' | 'info' | 'warn' | 'danger' | 'success'

interface Props extends Omit<BoxProps, 'color'> {
  tone?: Tone
}

const Styled = styled(Box, {
  shouldForwardProp: (p) => p !== 'tone',
})<{ tone: Tone }>(({ tone }) => {
  const tones: Record<Tone, { bg: string; fg: string }> = {
    neutral: { bg: colorTokens.bg.muted, fg: colorTokens.fg.muted },
    info: { bg: colorTokens.state.infoBg, fg: colorTokens.state.infoFg },
    warn: { bg: colorTokens.state.warnBg, fg: colorTokens.state.warnFg },
    danger: { bg: colorTokens.state.dangerBg, fg: colorTokens.state.dangerFg },
    success: {
      bg: colorTokens.state.successBg,
      fg: colorTokens.state.successFg,
    },
  }
  const t = tones[tone]
  return {
    display: 'inline-flex',
    alignItems: 'center',
    height: 16,
    padding: '0 6px',
    borderRadius: RADIUS.sm,
    background: t.bg,
    color: t.fg,
    fontSize: typeScale.tag.fontSize,
    fontWeight: typeScale.tag.fontWeight,
    lineHeight: typeScale.tag.lineHeight,
    letterSpacing: 0,
  }
})

export const Tag = ({ tone = 'neutral', ...rest }: Props) => (
  <Styled tone={tone} {...rest} />
)
